/**
 * Social integration schemas — OAuth connection status per platform.
 */
import { z } from "zod";
export const SOCIAL_PLATFORMS = ["meta", "instagram", "linkedin", "twitter"];
export const SocialIntegrationStatusSchema = z.object({
    platform: z.enum(SOCIAL_PLATFORMS),
    connected: z.boolean(),
    account_name: z.string().nullable(),
    connected_at: z.string().datetime().nullable(),
});
/** GET /settings/integrations */
export const IntegrationsListResponseSchema = z.object({
    integrations: z.array(SocialIntegrationStatusSchema),
});
/** POST /settings/integrations/:platform/connect response */
export const IntegrationConnectResponseSchema = z.object({
    auth_url: z.string().url(),
});
//# sourceMappingURL=integrations.js.map